<template>
  <nuxt-link
    class="ArticleListingCard group"
    :to="'/' + story.full_slug"
  >
    <div class="relative overflow-hidden">
      <nuxt-img
        v-if="story.content?.summaryImage?.filename"
        preset="standard"
        :loading="eager ? 'eager' : 'lazy'"
        :fetchpriority="eager ? 'high' : undefined"
        sizes="sm:100vw desk:746px"
        :src="story.content.summaryImage.filename"
        :alt="story.content.summaryTitle"
        class="w-full object-cover aspect-wide opacity-100 group-hover:opacity-80 transition-all duration-500 ease-out"
        :class="story.content.summaryFocalPoint"
      />
      <div
        v-if="story.content.summaryTime"
        class="absolute bottom-12 left-12 pl-6 desk:pl-8 pr-10 desk:pr-12 h-20 desk:h-24 flex justify-center items-center gap-4 desk:gap-6 bg-bg-inverse text-text-inverse type-headline-xs opacity-90 rounded-full group-hover:opacity-100"
      >
        <img
          src="/icons/play-circle-inv.svg"
          class="w-12 desk:w-16 h-12 desk:h-16"
        >
        <span> {{ story.content.summaryTime }} </span>
      </div>
    </div>
    <div class="pt-16 flex flex-col items-start gap-8">
      <div v-if="story.content.summaryCategories.length" class="flex gap-8">
        <div
          v-for="keyword in keywords"
          :key="keyword"
          class="type-tagline text-text-subtle"
        >
          {{ keyword }}
        </div>
      </div>
      <div class="group-hover:underline underline-offset-4 decoration-1">{{ story.content.summaryTitle }}</div>
    </div>
  </nuxt-link>
</template>

<script setup lang="ts">
import { StoryBlokArticlePage } from '#constants/types/storyblok';
const { $t } = useNuxtApp();

const props = defineProps<{
  story: StoryBlokArticlePage,
  eager?: boolean,
}>();

const keywords = computed(()=> {
  // Safety because we changed format in storyblok
  if (!props.story.content.summaryCategories || typeof props.story.content.summaryCategories === 'string') {
    return [];
  }

  return props.story.content.summaryCategories.map(m => $t(`articles.keyword.${m}`));
});

</script>